import React from 'react'
import { Table, Th, Td, Tr, Badge } from '@/shared/ui'

function iso(v?: string | null) {
  return v ? new Date(v).toLocaleString() : '-'
}

function cents(v?: number | null) {
  return `R$ ${(Number(v || 0) / 100).toFixed(2)}`
}

type Row = {
  commission_id: string
  account_id?: string | null
  amount_cents?: number | null
  status?: string | null
  period_start?: string | null
  period_end?: string | null
  matures_at?: string | null
}

function maskName(name?: string | null, fallback?: string | null) {
  const n = String(name || '').trim()
  if (!n) {
    const f = String(fallback || '')
    if (!f) return '-'
    return `${f.slice(0, 4)}...${f.slice(-4)}`
  }
  const parts = n.split(/\s+/).filter(Boolean)
  const first = parts[0] || ''
  const last = parts.length > 1 ? parts[parts.length - 1] : parts[0]
  const left = first.slice(0, Math.min(4, first.length))
  const right = last.slice(-Math.min(4, last.length))
  return `${left}... ...${right}`
}

export default function CommissionsTable({
  rows,
  accountNames,
}: {
  rows: Row[]
  accountNames?: Record<string, string>
}) {
  return (
    <Table>
      <thead>
        <Tr>
          <Th>Cliente</Th>
          <Th>Status</Th>
          <Th>Valor</Th>
          <Th>Matura em</Th>
        </Tr>
      </thead>
      <tbody>
        {rows.map((c) => (
          <Tr key={c.commission_id}>
            <Td>{maskName(accountNames?.[String(c.account_id || '')] || '', String(c.account_id || ''))}</Td>
            <Td>
              <Badge variant="soft" className="capitalize">
                {c.status}
              </Badge>
            </Td>
            <Td>{cents(c.amount_cents)}</Td>
            <Td>{iso(c.matures_at)}</Td>
          </Tr>
        ))}
        {rows.length === 0 && (
          <Tr>
            <Td colSpan={4} className="py-6 text-center text-sm text-foreground/70">
              Sem comissões.
            </Td>
          </Tr>
        )}
      </tbody>
    </Table>
  )
}

